import type { MapData } from "../types";
import {
  loadNaturalEarthAdm0,
  NaturalEarthProps,
} from "./loadNaturalEarthAdm0";

const WORLD_MAJOR_ADM0_A3 = new Set([
  "ARG",
  "AUS",
  "BRA",
  "CAN",
  "CHN",
  "DEU",
  "EGY",
  "ESP",
  "FRA",
  "GBR",
  "IDN",
  "IND",
  "IRN",
  "ITA",
  "JPN",
  "MEX",
  "POL",
  "RUS",
  "SAU",
  "TUR",
  "UKR",
  "USA",
  "ZAF",
]);

export async function loadWorldAdm0(): Promise<MapData> {
  return loadNaturalEarthAdm0((props: NaturalEarthProps) =>
    WORLD_MAJOR_ADM0_A3.has(props.ADM0_A3),
  );
}
